<template>
  <div style="position: relative; border-radius: 8px; overflow: hidden;">
    <GmapMap ref="mapRef" :center="{ lat: center[0], lng: center[1] }" :zoom="zoom" :options="mapOptions"
      style="min-height: 567px; width: 100%; z-index: 0;">
      <GmapCluster ref="clusterRef" :styles="clusterStyles">
        <PulseMarker v-for="(m, index) in markers" :key="index" :position="m" />
      </GmapCluster>
    </GmapMap>

    <!-- Zoom controls -->
    <div class="map-zoom-controls">
      <button class="map-zoom-btn" @click="zoomIn">+</button>
      <button class="map-zoom-btn" @click="zoomOut">−</button>
    </div>
  </div>
</template>

<script>
import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCluster from 'vue2-google-maps/src/components/cluster'
import PulseMarker from './PulseMarker.vue'

export default {
  name: 'DomainSummaryHeatmap',
  components: {
    GmapMap: VueGoogleMaps.Map,
    GmapCluster,
    PulseMarker,
  },
  props: {
    clusters: {
      type: Array,
      default: () => [],
      // each item: { lat, lng }
    },
  },
  data() {
    return {
      zoom: 5,
      center: [-2.548926, 118.0148634],
      mapOptions: {
        disableDefaultUI: true,
      },
    }
  },
  computed: {
    markers() {
      return this.clusters
        .filter(c => c.lat && c.lng && parseFloat(c.lat) !== 0 && parseFloat(c.lng) !== 0)
        .map(c => ({ lat: parseFloat(c.lat), lng: parseFloat(c.lng) }))
    },
    clusterStyles() {
      const size = 40
      const url = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(
        `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}">` +
        `<circle cx="${size / 2}" cy="${size / 2}" r="${size / 2 - 2}" fill="#eb5464" stroke="#eb5464" stroke-width="2"/>` +
        '</svg>'
      )
      return [{ url, height: size, width: size, textColor: '#ffffff', textSize: 14 }]
    },
  },
  mounted() {
    this.$refs.clusterRef.$clusterPromise.then(cluster => {
      cluster.setClusterClass('devices-monitor-cluster')
    })
  },
  methods: {
    zoomIn() {
      this.zoom = Math.min(this.zoom + 1, 18)
    },
    zoomOut() {
      this.zoom = Math.max(this.zoom - 1, 1)
    },
  },
}
</script>

<style scoped>
.map-zoom-controls {
  position: absolute;
  bottom: 40px;
  right: 10px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.map-zoom-btn {
  width: 27px;
  height: 27px;
  background: white;
  border: 1px solid #eaeaea;
  border-radius: 4px;
  cursor: pointer;
  font-size: 17px;
  line-height: 1;
  color: #2f2f2f;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.map-zoom-btn:hover {
  background: #f5f5f5;
}
</style>

<style>
.devices-monitor .radar-md-green,
.devices-monitor .radar-md-yellow,
.devices-monitor .radar-md-red {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  position: relative;
}

.devices-monitor .radar-md-green::before,
.devices-monitor .radar-md-yellow::before,
.devices-monitor .radar-md-red::before {
  content: "";
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1);
  opacity: 0.3;
}

.devices-monitor .radar-md-green {
  background: #1ca967;
}

.devices-monitor .radar-md-green::before {
  background: #1ca967;
  animation: pulse-green 3s ease-out infinite;
}

.devices-monitor .radar-md-yellow {
  background: #e4aa27;
}

.devices-monitor .radar-md-yellow::before {
  background: #e4aa27;
  animation: pulse-yellow 2s ease-out infinite;
}

.devices-monitor .radar-md-red {
  background: #cc2132;
}

.devices-monitor .radar-md-red::before {
  background: #cc2132;
  animation: pulse-red 1s ease-out infinite;
}

@keyframes pulse-green {
  0% {
    transform: translate(-50%, -50%) scale(0.5);
    opacity: 0;
  }
  50% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.3;
  }
  100% {
    transform: translate(-50%, -50%) scale(2.5);
    opacity: 0;
  }
}

@keyframes pulse-yellow {
  0% {
    transform: translate(-50%, -50%) scale(0.5);
    opacity: 0;
  }
  50% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.3;
  }
  100% {
    transform: translate(-50%, -50%) scale(2.5);
    opacity: 0;
  }
}

@keyframes pulse-red {
  0% {
    transform: translate(-50%, -50%) scale(0.5);
    opacity: 0;
  }
  50% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.3;
  }
  100% {
    transform: translate(-50%, -50%) scale(2.5);
    opacity: 0;
  }
}

.devices-monitor-cluster::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #eb5464;
  opacity: 0.3;
  transform: scale(1);
  animation: pulse-cluster 1s ease-out infinite;
}

@keyframes pulse-cluster {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  50% {
    transform: scale(1);
    opacity: 0.3;
  }
  100% {
    transform: scale(2.5);
    opacity: 0;
  }
}
</style>
